import locale from "localization";
import styles from "./shift-records-details-cash-and-non-cash.module.scss";
import { Title } from "components/commons";
import { cashTransactionMapper } from "././shift-records-details-cash-non-cash.mapper";
import { cashTransactionColumn } from "./shift-records-details-cash-non-cash-column";
import DataTableV2 from "components/commons/data-table/data-table-v2";
import { initialFilterState } from "modules/shift-records/shift-records-filter.state";
import useDataTable from "hooks/useDataTable";
import { useCallback, useMemo, useState } from "react";
import { isArray, sortBy } from "lodash";
import Big from "big.js";
import { useModal } from "hooks";
import CashTransactionModal from "./cash-transaction-modal/cash-transaction-modal";

const ShiftDetailsCash = ({ shift, pageMode, updateTransactionPaymentMethod }) => {
  // const pumpDiscounts = useMemo(() => shift?.shiftDiscounts || [], [shift]);

  const transactionsItemDetails = useMemo(() => {
    const result = [];
    Object.entries(shift.transactionItem).forEach(([key, productTransaction]) => {
      if (!key.toLowerCase().includes("item") && isArray(productTransaction)) {
        result.push(...productTransaction.filter((t) => !t.transaction.adjustmentType));
      }
    });

    return result;
  }, [shift.transactionItem]);

  // const computeTotalDiscount = (items) => {
  //   return sumBy(
  //     items.map((t) => {
  //       const originalTotalAmount = getPrice(nameToSku(t.name)) * t.quantity;

  //       const totalPromoDiscount = t.discount && t.pumpDiscountPerItem === 0 ? t.totalDiscount : 0;

  //       const pumpDiscountPerItem = t.pumpDiscountPerItem;
  //       let totalPumpDiscount = pumpDiscountPerItem * t.quantity;
  //       let vat = t.vat === 0 ? originalTotalAmount - originalTotalAmount / 1.12 : 0;
  //       if (vat > 0 && totalPumpDiscount > 0) {
  //         vat = vat - totalPumpDiscount + totalPumpDiscount / 1.12;
  //         // totalPumpDiscount = 0;
  //       }
  //       let totalDiscount = vat + totalPromoDiscount + totalPumpDiscount;

  //       return {
  //         totalDiscount: totalDiscount,
  //       };
  //     }),
  //     "totalDiscount"
  //   );
  // };

  // const computeDisplayedTotalDiscount = (items) => {
  //   return sumBy(
  //     items.map((t) => {
  //       const originalTotalAmount = getPrice(nameToSku(t.name)) * t.quantity;

  //       const totalPromoDiscount = t.discount && t.pumpDiscountPerItem === 0 ? t.totalDiscount : 0;

  //       const pumpDiscountPerItem = t.pumpDiscountPerItem;
  //       let totalPumpDiscount = pumpDiscountPerItem * t.quantity;
  //       let vat = t.vat === 0 ? originalTotalAmount - originalTotalAmount / 1.12 : 0;
  //       if (vat > 0 && totalPumpDiscount > 0) {
  //         vat = vat - totalPumpDiscount;
  //         // totalPumpDiscount = 0;
  //       }
  //       let totalDiscount = vat + totalPromoDiscount + totalPumpDiscount;

  //       return {
  //         totalDiscount: totalDiscount,
  //       };
  //     }),
  //     "totalDiscount"
  //   );
  // };

  // const computeTotalPumpDiscount = (items) => {
  //   return sumBy(
  //     items.map((t) => {
  //       const pumpDiscountPerItem =
  //         t.vat === 0 && t.pumpDiscountPerItem > 0
  //           ? t.pumpDiscountPerItem / 1.12
  //           : t.pumpDiscountPerItem;

  //       const totalPumpDiscount = pumpDiscountPerItem * t.quantity;

  //       return {
  //         totalPumpDiscount: totalPumpDiscount,
  //       };
  //     }),
  //     "totalPumpDiscount"
  //   );
  // };

  // const mapCashTransaction = (cashItem) => {
  //   let totalAmount = cashItem.totalAmount - cashItem.excessAmount;

  //   let finalAmount = totalAmount - cashItem.discount;
  //   let discount = cashItem.discount;

  //   const transactionItem = transactionsItemDetails.find(
  //     (sale) =>
  //       sale.transactionId === cashItem.transactionId &&
  //       sale.transactionItemId === cashItem.transactionItemId
  //   );

  //   // STOCQ-5847: Tax VAT Exempt fuel — Amount shows pricing.pricePerLiter × quantity minus
  //   // the POS-stored (already VAT-adjusted) pump discount; Discount column shows the pump
  //   // discount magnitude; Final uses POS netTotalAmount. The existing branches below
  //   // compute `discount = 0` (because cashItem.vat === 0 zeroes promoDiscount and the
  //   // pump-discount branch only triggers when transactionItem.discount === "") so this
  //   // case had no display path.
  //   if (cashItem.type === "fuel" && isTaxVatExemptItem(cashItem)) {
  //     const pricePerLiter =
  //       find(shift.shift.pricing, { product: nameToSku(cashItem.name) })?.pricePerLiter || 0;
  //     const itemForFormula = {
  //       quantity: cashItem.quantity,
  //       totalPumpDiscount: transactionItem?.totalPumpDiscount ?? 0,
  //     };
  //     const taxVatExemptAmount = computeTaxVatExemptFuelAmount(itemForFormula, pricePerLiter);
  //     const pumpDiscountMagnitude = Math.abs(transactionItem?.totalPumpDiscount ?? 0);
  //     return {
  //       ...cashItem,
  //       totalAmount: taxVatExemptAmount,
  //       finalAmount: transactionItem?.netTotalAmount ?? cashItem.finalAmountPaid ?? totalAmount,
  //       discount: pumpDiscountMagnitude,
  //     };
  //   }

  //   const pumpNumber = Number(String(transactionItem.pump).split(" ")[1]);
  //   const pumpDiscount = shift.shiftDiscounts.find(
  //     (discount) =>
  //       discount.product === nameToSku(cashItem.name) && Number(discount.pumpSlot) === pumpNumber
  //   );

  //   const isNoDiscountFuel =
  //     cashItem.type === "fuel" &&
  //     transactionItem?.discount === "" &&
  //     (transactionItem?.pumpDiscountPerItem ?? 0) === 0;

  //   const pumpDiscountPerLiter = isNoDiscountFuel
  //     ? 0
  //     : transactionItem?.pumpDiscountPerItem ?? pumpDiscount?.discountPerLiter ?? 0;
  //   const totalPumpDiscount =
  //     transactionItem?.discount === ""
  //       ? cashItem.vat === 0
  //         ? (pumpDiscountPerLiter / 1.12) * cashItem.quantity
  //         : pumpDiscountPerLiter * cashItem.quantity
  //       : 0;
  //   const vatAmount = cashItem.vat === 0 ? totalAmount - totalAmount / 1.12 : 0;
  //   const promoDiscount =
  //     transactionItem?.discount !== "" && cashItem.vat !== 0 ? cashItem.discount : 0;

  //   discount = Math.round((totalPumpDiscount + promoDiscount) * 100) / 100;
  //   if (cashItem.type === "fuel") {
  //     // STOCQ-5882: For no-discount fuel in a split payment, cashItem.totalAmount is this
  //     // payment method's share (e.g. 166.67 of a 200 diesel paid 1000 cash + 200 gift-card).
  //     // The unconditional substitution to originalTotalAmount (200, the whole item) breaks that
  //     // share. Only substitute when there is actually a fuel discount that needs the gross base.
  //     if (!isNoDiscountFuel) {
  //       totalAmount = transactionItem?.originalTotalAmount ?? totalAmount;
  //     }
  //     const fuelVatAmount = cashItem.vat === 0 ? totalAmount - totalAmount / 1.12 : 0;
  //     finalAmount = isNoDiscountFuel
  //       ? Math.round((totalAmount - fuelVatAmount) * 100) / 100
  //       : transactionItem?.netTotalAmount ?? Math.round((totalAmount - discount) * 100) / 100;
  //   } else {
  //     finalAmount = Math.round((totalAmount - discount - vatAmount) * 100) / 100;
  //     if (cashItem.type === "lpg" && cashItem.vat === 0) {
  //       discount = 0;
  //       finalAmount = cashItem.finalAmountPaid;
  //     }
  //   }

  //   return { ...cashItem, totalAmount, finalAmount, discount };
  // };

  const sortCashTransactions = (items) => {
    // const result = items.map((transaction) => {
    //   const saleTransaction = transactionsItemDetails.find(
    //     (t) => t.transactionItemId === transaction.transactionItemId
    //   );

    //   // Calculate product amount (originalTotalAmount)
    //   let productAmount = 0;
    //   if (saleTransaction) {
    //     const totalPumpDiscountWithoutVat =
    //       (saleTransaction.pumpDiscountPerItem || 0) * (saleTransaction.quantity || 0);
    //     productAmount =
    //       saleTransaction.vat === 0 && saleTransaction.pumpDiscountPerItem !== 0
    //         ? (saleTransaction.quantity || 0) * (saleTransaction.originalPricePerItem || 0) +
    //           totalPumpDiscountWithoutVat -
    //           (saleTransaction.totalPumpDiscount || 0)
    //         : (saleTransaction.originalTotalAmount || 0) - (saleTransaction.totalPumpDiscount || 0);
    //   }

    //   // Get the product discount from the transaction itself (already proportional value)
    //   const productDiscount = transaction.discount || 0;

    //   // Get the total transaction amount
    //   const transactionTotalAmount = saleTransaction?.transaction?.amount || 0;

    //   // Find the payment method amount for cash
    //   const paymentMethodRecord = saleTransaction?.transaction?.paymentMethods?.find(
    //     (pm) => pm.method === "cash"
    //   );
    //   const paymentMethodAmount = paymentMethodRecord?.amount || 0;

    //   let totalDiscount = 0;
    //   let totalAmount = transaction.totalAmount - (transaction.excessAmount || 0);
    //   let finalAmount = transaction.finalAmount;
    //   if (transaction.type === "fuel") {
    //     const { discount: fuelDiscount, finalAmount: fuelFinalAmount, totalAmount: fuelTotalAmount } = mapCashTransaction(transaction);
    //     totalDiscount = fuelDiscount;
    //     finalAmount = fuelFinalAmount;
    //     totalAmount = fuelTotalAmount;
    //   } else {
    //     const nonFuelTransactionItem = transactionsItemDetails.find(
    //       (t) =>
    //         t.transactionId === transaction.transactionId &&
    //         t.transactionItemId === transaction.transactionItemId
    //     );
    //     const hasNoPromoDiscount =
    //       !nonFuelTransactionItem?.discount || nonFuelTransactionItem?.discount === "";
    //     // STOCQ-5847: Tax VAT Exempt non-fuel (e.g. lubes with txn discount) — the legacy
    //     // isVatExempt gate required totalDiscount === 0 which excluded this case. Branch
    //     // here to compute vatAdjustment = vatExempt × 0.12 and trust the POS-stored
    //     // netTotalAmount/finalAmountPaid for Final.
    //     const isTaxVatExemptRow = isTaxVatExemptItem(transaction);
    //     const isLegacyVatExempt =
    //       !isTaxVatExemptRow && transaction.vat === 0 && hasNoPromoDiscount;
    //     const absDiscount = Math.abs(transaction.discount || 0);
    //     if (isTaxVatExemptRow) {
    //       const vatAdjustment = computeTaxVatExemptMagnitude(transaction);
    //       totalDiscount = absDiscount;
    //       totalAmount = transaction.totalAmount;
    //       finalAmount =
    //         nonFuelTransactionItem?.netTotalAmount ??
    //         transaction.finalAmountPaid ??
    //         Math.round((transaction.totalAmount - totalDiscount - vatAdjustment) * 100) / 100;
    //     } else {
    //       const vatAdjustment = isLegacyVatExempt
    //         ? transaction.totalAmount - transaction.totalAmount / 1.12
    //         : 0;
    //       // STOCQ-5883: data convention stores per-row `discount` as negative when an actual
    //       // discount is applied (e.g. lubricant -65). Use the positive magnitude so the
    //       // deduction in finalAmount works correctly (totalAmount − |discount| − vatAdjustment).
    //       totalDiscount = isLegacyVatExempt ? 0 : absDiscount;
    //       totalAmount = transaction.totalAmount;
    //       finalAmount = Math.round((transaction.totalAmount - totalDiscount - vatAdjustment) * 100) / 100;
    //       if (transaction.type === "lpg" && transaction.vat === 0) {
    //         totalDiscount = 0;
    //         finalAmount = transaction.finalAmountPaid;
    //       }
    //     }
    //   }

    //   return {
    //     ...transaction,
    //     // STOCQ-5883: cashTransactionMapper's existing display logic expects a positive
    //     // magnitude for a real discount (renders as "-X" in red). Normalize here so both
    //     // fuel (mapCashTransaction returns negative) and non-fuel paths land in the same
    //     // convention.
    //     discount: Math.abs(totalDiscount || 0),
    //     totalAmount,
    //     finalAmount,
    //     vat: transaction.vat,
    //     productAmount,
    //     productDiscount,
    //     transactionTotalAmount,
    //     paymentMethodAmount,
    //   };
    // });

    // const result = items.map((t) => {
    //   const sourceItem = saleTransactionsDetailed.find(
    //     (sale) => sale.transactionItemId === t.transactionItemId
    //   );

    //   const transactionGross = sourceItem?.transaction?.grossTotalAmount || 1;

    //   // ✅ Discount: post-excess amount / transaction grossTotalAmount × combined total discount
    //   const allTransactionItems = saleTransactionsDetailed.filter(
    //     (sale) => sale.transactionId === t.transactionId
    //   );
    //   const combinedTotalDiscount = allTransactionItems.reduce(
    //     (sum, item) => sum + Math.abs(item.totalDiscount || 0),
    //     0
    //   );

    //   const isNotSplitPayment =
    //     shift.transactionPaymentMethod.nonCash
    //       .filter((nonCash) => nonCash.transactionId === t.transactionId)
    //       .every((nonCash, _, arr) => nonCash.method === arr[0].method) &&
    //     shift.transactionPaymentMethod.cash.filter((cash) => cash.transactionId === t.transactionId)
    //       .length === 0; // ✅ no cash payments in this transaction

    //   // const isCashOnly = shift.transactionPaymentMethod.nonCash.length === 0;
    //   const isCashOnly =
    //     shift.transactionPaymentMethod.nonCash.filter(
    //       (nonCash) => nonCash.transactionId === t.transactionId
    //     ).length === 0;

    //   const pricePerUnit =
    //     t.type === "fuel"
    //       ? shift.shift.pricing.find((p) => p.product === nameToSku(sourceItem.name))
    //           ?.pricePerLiter || 0
    //       : sourceItem?.originalPricePerItem || 0;

    //   // ✅ Payment face value for POS-level discount and amount input totalAmount
    //   const productGr1oss = sourceItem?.grossTotalAmount || 0;

    //   // ✅ Detect amount input — sourceItem quantity is clean up to 3 decimal places
    //   const isAmountInput =
    //     t.type === "fuel" &&
    //     sourceItem?.quantity === parseFloat(Number(sourceItem?.quantity).toFixed(2));

    //   let totalAmount = t.quantity * pricePerUnit;

    //   if (Math.abs(totalAmount - t.totalAmount) <= 0.1) {
    //     totalAmount = t.type === "fuel" ? truncate(t.totalAmount, 2) : t.totalAmount;
    //   }

    //   const computeDiscount = () => {
    //     return -(
    //       Math.round(
    //         (t.totalAmount / transactionGross) * truncate(combinedTotalDiscount, 2) * 100
    //       ) / 100
    //     );
    //   };

    //   let discount = isCashOnly
    //     ? sumBy(
    //         saleTransactionsDetailed
    //           .filter((transaction) =>
    //             transaction.type === "fuel"
    //               ? transaction.pump === t.pumpNumber && transaction.sku === t.sku
    //               : transaction.sku === t.sku
    //           )
    //           .map((transaction) => {
    //             const isVatOnly =
    //               transaction.vat === 0 &&
    //               transaction.discount === "" &&
    //               transaction.pumpDiscountPerItem === 0;

    //             let totalDiscount = transaction.totalDiscount;
    //             if (isVatOnly) {
    //               totalDiscount = 0;
    //             }

    //             return {
    //               totalDiscount:
    //                 transaction.discountValue < 0 ? -Math.abs(totalDiscount) : totalDiscount,
    //             };
    //           }),
    //         "totalDiscount"
    //       ) || 0
    //     : computeDiscount();

    //   // let discount =
    //   //   isCashOnly || t.discount > 0 || isNotSplitPayment ? t.discount : computeDiscount();

    //   // if (sourceItem.discountValue !== 0 && isCashOnly) {
    //   //   discount = computeDiscount();
    //   // }

    //   // if (sourceItem?.totalPumpDiscount > 0) {
    //   //   discount = computeDiscount();
    //   // }

    //   // const isDiscountWithVat = sourceItem.discount !== "" && sourceItem.vat === 0;
    //   // if (isDiscountWithVat) {
    //   //   discount = computeDiscount();
    //   // }

    //   // const isPumpDiscountOnly = sourceItem.totalPumpDiscount > 0 && sourceItem.vat > 0;
    //   // if (isPumpDiscountOnly) {
    //   //   discount = t.discount;
    //   // }

    //   // const isPumpDiscountWithVat = sourceItem.totalPumpDiscount > 0 && sourceItem.vat === 0;
    //   // if (isPumpDiscountWithVat) {
    //   //   discount = t.discount;
    //   // }

    //   // const isDiscountOnly =
    //   //   sourceItem.discount !== "" && sourceItem.vat > 0 && sourceItem.pumpDiscountPerItem === 0;
    //   // if (isDiscountOnly) {
    //   //   discount = t.discount;
    //   // }

    //   // if (sourceItem.discountValue !== 0 && isCashOnly && sourceItem.type !== "fuel") {
    //   //   discount = sourceItem.discountValue;
    //   // }

    //   const vatExempt =
    //     sumBy(
    //       saleTransactionsDetailed
    //         .filter((transaction) =>
    //           transaction.type === "fuel"
    //             ? transaction.pump === t.pumpNumber && transaction.sku === t.sku
    //             : transaction.sku === t.sku
    //         )
    //         .map((transaction) => {
    //           const computeTotalAmount = (transaction) => {
    //             const pricePerUnit =
    //               transaction.type === "fuel"
    //                 ? shift.shift.pricing.find((p) => p.product === nameToSku(transaction.name))
    //                     ?.pricePerLiter || 0
    //                 : transaction?.originalPricePerItem || 0;

    //             let grossTotalAmount = t.quantity * pricePerUnit;
    //             if (Math.abs(grossTotalAmount - transaction.grossTotalAmount) <= 0.1) {
    //               grossTotalAmount = truncate(transaction.grossTotalAmount, 2);
    //             }

    //             return grossTotalAmount;
    //           };
    //           const grossTotalAmount = computeTotalAmount(t);
    //           const rowIsTaxVatExempt = transaction.vat === 0;
    //           return {
    //             vatExempt: rowIsTaxVatExempt
    //               ? -(grossTotalAmount - grossTotalAmount / 1.12)
    //               : transaction.vatExempt12percent || 0,
    //           };
    //         }),
    //       "vatExempt"
    //     ) || 0;
    //   const finalAmount = Big(totalAmount).round(2).toNumber() + discount + vatExempt;
    //   return {
    //     ...t,
    //     finalAmount,
    //     discount,
    //     vatExempt,
    //     totalAmount,
    //   };
    // });
    const result = items;
    return sortBy(result, ["name", "pumpNumber"]);
  };

  // Enrich cash transactions with formula data
  const enrichedCashTransactions = useMemo(() => {
    const cashRefunds = (shift?.transactionPaymentMethod.refund || []).filter(
      (r) => r.method === "cash",
    );

    const allCash = [...(shift?.transactionPaymentMethod.cash || [])].map((cash) => {
      const refund = cashRefunds.find((r) => r.sku === cash.sku);
      if (refund) {
        const refundDiscount =
          refund.discount !== 0 && refund.vatAmount !== 0
            ? Big(refund.discount).add(refund.vatAmount).toNumber()
            : refund.discount;

        const quantity = Big(cash.quantity).add(refund.quantity).toNumber();
        const totalAmount = Big(cash.totalAmount).add(refund.totalAmount).toNumber();
        const discount = Big(cash.discount).minus(refundDiscount).toNumber();
        const vatAmount = Big(cash.vatAmount).add(refund.vatAmount).toNumber();
        const finalAmount = Big(totalAmount).add(discount).add(vatAmount).toNumber();

        return {
          ...cash,
          quantity: quantity,
          totalAmount: totalAmount,
          finalAmount: finalAmount,
          discount: discount,
          vatAmount: vatAmount,
        };
      } else {
        return cash;
      }
    });

    const fuelItems = sortCashTransactions(allCash.filter((item) => item.type === "fuel"));
    const nonFuelItems = sortCashTransactions(allCash.filter((item) => item.type !== "fuel"));

    const result = [...fuelItems, ...nonFuelItems];

    return result;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    shift?.transactionPaymentMethod.cash,
    shift?.transactionPaymentMethod.refund,
    transactionsItemDetails,
  ]);

  const cashTransactionModal = useModal();
  const [selectedCashRow, setSelectedCashRow] = useState(null);

  const onViewCashTransaction = useCallback(
    (row) => {
      setSelectedCashRow(row);
      cashTransactionModal.show({});
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  const cashTransactions = shift?.transactionPaymentMethod?.cashTransactions;
  const selectedCashTransactions = useMemo(() => {
    if (!selectedCashRow) {
      return [];
    }
    return (cashTransactions ?? enrichedCashTransactions)
      .filter(
        (item) =>
          item.sku === selectedCashRow.sku &&
          (selectedCashRow.type !== "fuel" || item.pumpNumber === selectedCashRow.pumpNumber),
      )
      .sort((a, b) =>
        String(b.transactionNumber ?? "").localeCompare(
          String(a.transactionNumber ?? ""),
          undefined,
          { numeric: true },
        ),
      );
  }, [selectedCashRow, cashTransactions, enrichedCashTransactions]);

  const cashRows = useMemo(
    () =>
      enrichedCashTransactions.map((row) => {
        if (!cashTransactions) return row;
        const rowTransactions = cashTransactions.filter(
          (item) =>
            item.sku === row.sku && (row.type !== "fuel" || item.pumpNumber === row.pumpNumber),
        );
        return {
          ...row,
          transactionCount: new Set(rowTransactions.map((t) => t.transactionId)).size,
          adjustmentCount: new Set(
            rowTransactions.filter((t) => t.adjustedAt).map((t) => t.transactionId),
          ).size,
        };
      }),
    [enrichedCashTransactions, cashTransactions],
  );

  const { table } = useDataTable({
    value: cashRows,
    filter: { initialState: initialFilterState(), mapper: (data) => data },
    table: {
      key: "cash",
      name: "cashTransactions",
      mapper: (val) =>
        cashTransactionMapper({
          val,
          transactionsItemDetails,
          onViewCashTransaction,
        }),
      columns: cashTransactionColumn,
    },
  });

  return (
    <>
      <Title small black>
        {locale.cashTransactions}
      </Title>
      <div className={styles.spacer10} />
      <div className={styles.tableContainer}>
        <DataTableV2 {...table} hideNoSearchResultRender tableVersion="v2" hidePagination />
      </div>
      <div className={styles.spacer50} />
      <CashTransactionModal
        cashRow={selectedCashRow}
        cashTransactions={selectedCashTransactions}
        allCashTransactions={cashTransactions ?? enrichedCashTransactions}
        transactionsItemDetails={transactionsItemDetails}
        pageMode={pageMode}
        updateTransactionPaymentMethod={updateTransactionPaymentMethod}
        {...cashTransactionModal}
      />
    </>
  );
};

export default ShiftDetailsCash;
